module.exports = __webpack_public_path__ + "static/media/student-3.3359dcd9.png";